/**
 * Точка входа webpack: landing.suggest
 */
import './suggest.css';
import '../../common.js';
import '../../modules/partners/partners.js';
import { initFaq } from '../../modules/faq/faq.js';
import { initReviews } from '../../modules/reviews/reviews.js';

/** Открывает чат поддержки по ссылке «Задать вопрос». */
function initTryingChat() {
    document.querySelectorAll('.trying__chat').forEach((link) => {
        link.addEventListener('click', (event) => {
            event.preventDefault();
            if (typeof Verbox === 'function') {
                Verbox('openSupport');
            }
        });
    });
}

function init() {
    initFaq();
    initTryingChat();
    initReviews();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
} else {
    init();
}
